import React from "react";

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { userWatchedKpiQuery } from "./userActivity.queries";
import StatCard, {
  formatCountOrEmpty,
  formatDurationOrEmpty,
} from "../kpi/StatCard";

import type { JSX } from "react";

interface UserKpiGridProps {
  userUuid: string;
}

function UserKpiGrid({ userUuid }: UserKpiGridProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t, i18n } = useTranslation("editor-analytics");
  const lang = i18n.language;

  const result = useQuery({
    ...userWatchedKpiQuery(projectSlug, userUuid),
    enabled: !!userUuid,
  });
  const kpi = result.data?.data[0];

  return (
    <div className="grid grid-cols-2 gap-4 @3xl:grid-cols-4">
      <StatCard
        label={t("watchedMediaTotal")}
        query={result}
        scope="asOfToday"
        value={formatCountOrEmpty(kpi?.watched_media_total, lang)}
      />
      <StatCard
        label={t("watchedMediaThisMonth")}
        query={result}
        value={formatCountOrEmpty(kpi?.watched_media_month, lang)}
      />
      <StatCard
        label={t("playtimeTotal")}
        query={result}
        scope="asOfToday"
        value={formatDurationOrEmpty(kpi?.playtime_total)}
      />
      <StatCard
        label={t("playtimeThisMonth")}
        query={result}
        value={formatDurationOrEmpty(kpi?.playtime_month)}
      />
    </div>
  );
}

export default UserKpiGrid;
